var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cake_brands_inner_padding", style: _vm.Styles },
    [
      _c(
        "div",
        {
          staticClass: "cake_brands_inner",
          class: _vm.cakeContentClass,
          style: {
            "background-color":
              _vm.value.config.type === 2 &&
              _vm.value.config.bg_style === 2 &&
              _vm.value.config.bg_color
                ? _vm.value.config.bg_color
                : "#fff",
          },
        },
        [
          _vm.value.config.type === 1 || _vm.value.config.name
            ? _c("div", { staticClass: "header" }, [
                _c("div", { staticClass: "left" }, [
                  _vm.value.config.show_title_icon !== 0
                    ? _c("div", { staticClass: "icon" })
                    : _vm._e(),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.value.config.name)),
                  ]),
                ]),
                _vm._m(0),
              ])
            : _vm._e(),
          _vm.value.config.type === 2
            ? _c(
                "div",
                { staticClass: "content2" },
                _vm._l(_vm.brandList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: ["item", "item" + _vm.value.config.cols],
                    },
                    [
                      _c(
                        "el-image",
                        {
                          staticClass: "img",
                          attrs: { src: item.brand_logo, fit: "contain" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [_c("i", { staticClass: "el-icon-more" })]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(item.brand_name)),
                      ]),
                    ],
                    1
                  )
                }),
                0
              )
            : _c(
                "div",
                { staticClass: "content" },
                [
                  _c(
                    "el-row",
                    { staticClass: "myRow", attrs: { gutter: 5 } },
                    _vm._l(_vm.brandList, function (item) {
                      return _c(
                        "el-col",
                        {
                          key: item.id,
                          staticClass: "brand",
                          attrs: { span: 6 },
                        },
                        [
                          _c("el-image", {
                            staticClass: "img",
                            attrs: { src: item.brand_logo, fit: "contain" },
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right" }, [
      _vm._v(" 更多 "),
      _c("i", { staticClass: "el-icon el-icon-arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }